import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Input from "@components/Input";
import { defaultUnits } from '@config';
import { unitTransform } from '@services/helper.service';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { standardList } from './../../../../app.values';

class Standard extends Component {

  static propTypes = {
    combination: PropTypes.object.isRequired
  };

  render () {
    const { combination: { extraField = {}} } = this.props;

    return (
      <div className="calculation fire-duration">
        <div className="custom-control custom-checkbox">
          <input
            className="custom-control-input"
            id="sustainedLoad"
            name="sustainedLoad"
            type="checkbox"
            checked={extraField.isSustained || false}
            onChange={(e) => {
              this.updateValue(!extraField.isSustained, "isSustained");
            }}
          />
          
         <Tooltip content={APP_TOOLTIPS.TOOLTIP_CHECKBOX_SUSTAINED_LOAD.Content}>
          <label className="custom-control-label" htmlFor="sustainedLoad"> {APP_TEXTS.SUSTAINED_LOAD.Content} </label>
          </Tooltip>
        </div>

        {extraField.isSustained  && (
          <Table className="w-50 mx-auto">
            <thead className="thead GeneralLoadingTable">
              <tr>
                {(this.props.designStandard === standardList['EU'] || this.props.designStandard === standardList['AnnexC']) ? (
                  <React.Fragment>
                    <th>N<sup>Sus</sup></th>
                    <th>M<span className="supsub"><sup>Sus</sup><sub>Ed,x</sub></span></th>
                    <th>M<span className="supsub"><sup>Sus</sup><sub>Ed,y</sub></span></th>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <th>N<sup>Sus</sup></th>
                    <th>M<span className="supsub"><sup>Sus</sup><sub>x</sub></span></th>
                    <th>M<span className="supsub"><sup>Sus</sup><sub>y</sub></span></th>
                  </React.Fragment>
                )}
                <th>[{this.props.loadUnit}&nbsp;/&nbsp;{this.props.momentUnit && this.props.momentUnit.replace(' ', "\u00A0")}]</th>
              </tr>
            </thead>

            <tbody className="tbody">
            <tr>
              <td>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SUSTAINED_LOAD_TENSILE_FORCE.Content}>
                <Input
                  id="nz-input"
                  type="number"
                  // postfix={unitLabel(this.props.loadUnit)}
                  value={unitTransform(+extraField.Nz || 0).from(defaultUnits.LOAD).to(this.props.loadUnit)}
                  onUpdate={value => {
                    this.updateValue(
                      unitTransform(+value, false).from(this.props.loadUnit).to(defaultUnits.LOAD),
                      'Nz'
                    );
                  }}
                  disabled={!extraField.isSustained}
                />
                </Tooltip>
              </td>
              <td>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SUSTAINED_LOAD_BENDING_MOMENT_X.Content}>
                <Input
                  id="nz-input"
                  type="number"
                  // postfix={unitLabel(this.props.momentUnit)}
                  value={unitTransform(+extraField.Mx || 0).from(defaultUnits.MOMENT).to(this.props.momentUnit)}
                  onUpdate={value => {
                    this.updateValue(
                      unitTransform(+value, false).from(this.props.momentUnit).to(defaultUnits.MOMENT),
                      'Mx'
                    );
                  }}
                  disabled={!extraField.isSustained}
                />
                </Tooltip>
              </td>
              <td>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SUSTAINED_LOAD_BENDING_MOMENT_Y.Content}>
                <Input
                  id="nz-input"
                  type="number"
                  // postfix={unitLabel(this.props.momentUnit)}
                  value={unitTransform(+extraField.My || 0).from(defaultUnits.MOMENT).to(this.props.momentUnit)}
                  onUpdate={value => {
                    this.updateValue(
                      unitTransform(+value, false).from(this.props.momentUnit).to(defaultUnits.MOMENT),
                      'My'
                    );
                  }}
                  disabled={!extraField.isSustained}
                />
                </Tooltip>
              </td>
            </tr>
            </tbody>
          </Table>
        )}
      </div>
    );
  }

  updateValue = (value, key) => {
    this.props.onUpdate({
      [key]: value
    });
  }

}

const mapState = state => ({
  designStandard: state.main.localization.designStandard,
  loadUnit: state.main.units.load,
  momentUnit: state.main.units.moment,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

export default connect(mapState)(Standard);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/Standard.js